// extracted by mini-css-extract-plugin
export default {"autoSuggestInput":"AutoSuggestInput_autoSuggestInput__VMXlP","options":"AutoSuggestInput_options__M8O-K","option":"AutoSuggestInput_option__aY6zN"};